import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Facebook, Instagram, Send } from 'lucide-react';

const TikTokIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const HeroSocialIcons = () => {
  return (
    <section className="relative overflow-hidden py-8 sm:py-10 bg-[#0a0a0a] border-b border-white/5">
      <div className="container relative z-10 mx-auto flex flex-col items-center px-4">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="mb-5 flex items-center gap-4 sm:gap-6"
        >
          <a
            href="https://www.tiktok.com/@phantompathvpn.com?is_from_webapp=1&sender_device=pc"
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#111] border border-white/10 flex items-center justify-center text-white hover:text-[#3affc2] hover:border-[#3affc2]/50 transition-all hover:-translate-y-1 touch-target shadow-md"
            aria-label="TikTok"
          >
            <TikTokIcon className="w-5 h-5" />
          </a>
          <a
            href="https://www.facebook.com/share/17t99Te3UD/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#111] border border-white/10 flex items-center justify-center text-white hover:text-[#3affc2] hover:border-[#3affc2]/50 transition-all hover:-translate-y-1 touch-target shadow-md"
            aria-label="Facebook"
          >
            <Facebook className="w-5 h-5" />
          </a>
          <a
            href="https://www.instagram.com/phantompathvpn?igsh=MWNmbHAxdzh0a3VoNA=="
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#111] border border-white/10 flex items-center justify-center text-white hover:text-[#3affc2] hover:border-[#3affc2]/50 transition-all hover:-translate-y-1 touch-target shadow-md"
            aria-label="Instagram"
          >
            <Instagram className="w-5 h-5" />
          </a>
          <a
            href="https://t.me/PhantomPathOfficial"
            target="_blank"
            rel="noopener noreferrer"
            className="w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-[#111] border border-white/10 flex items-center justify-center text-white hover:text-[#3affc2] hover:border-[#3affc2]/50 transition-all hover:-translate-y-1 touch-target shadow-md"
            aria-label="Telegram"
          >
            <Send className="w-5 h-5" />
          </a>
        </motion.div>

        <motion.a
          href="https://t.me/PhantomPathOfficial"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="group grid w-full max-w-3xl grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-2.5 rounded-xl border border-white/25 bg-transparent px-3 py-2 text-left shadow-[0_0_14px_rgba(255,255,255,0.04)] transition-all hover:-translate-y-0.5 hover:border-white/45 hover:shadow-[0_0_20px_rgba(255,255,255,0.08)] sm:gap-4 sm:px-5"
          aria-label="Join PhantomPath Telegram updates"
        >
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#229ed9]/40 bg-[#229ed9]/10 text-[#54bcea] shadow-[0_0_10px_rgba(34,158,217,0.14)] transition-transform group-hover:scale-105">
            <Send className="h-4 w-4" aria-hidden="true" />
          </span>
          <span className="min-w-0 flex-1">
            <span className="block text-xs font-bold text-white sm:text-sm">Direct from the Network</span>
            <span className="mt-0.5 block text-[9px] leading-[1.35] text-gray-400 sm:text-[11px]">Join our one-way Telegram update channel for real-time updates on server locations, maintenance windows, platform releases, and service announcements.</span>
          </span>
          <span className="flex shrink-0 items-center gap-1 text-[10px] font-bold text-[#54bcea] sm:text-xs">
            <span className="hidden sm:inline">Join Updates</span>
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
          </span>
        </motion.a>
      </div>
    </section>
  );
};

export default HeroSocialIcons;
